import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { FileText } from 'lucide-react';
import { BRAND_COLORS, BRAND_LABELS, BACKEND_URL } from '@/constants/bluemonk';

export const AssetLibraryTab = ({ inputRequests }) => {
  const assets = [];
  
  inputRequests.forEach(item => {
    item.submissions?.forEach(sub => {
      assets.push({
        ...sub,
        itemTitle: item.title,
        brand: item.brand,
      });
    });
  });

  if (assets.length === 0) {
    return (
      <Card className="p-8 text-center">
        <FileText className="h-12 w-12 text-slate-400 mx-auto mb-4" />
        <p className="text-lg font-medium text-slate-700">No assets yet</p>
        <p className="text-slate-500">Assets will appear here as you submit them</p>
      </Card>
    );
  }

  return (
    <Card className="overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-50 border-b">
            <tr>
              <th className="text-left p-4 font-semibold text-slate-700">Name</th>
              <th className="text-left p-4 font-semibold text-slate-700">Brand</th>
              <th className="text-left p-4 font-semibold text-slate-700">Type</th>
              <th className="text-left p-4 font-semibold text-slate-700">Submitted By</th>
              <th className="text-left p-4 font-semibold text-slate-700">Date</th>
              <th className="text-left p-4 font-semibold text-slate-700">Related Item</th>
              <th className="text-left p-4 font-semibold text-slate-700">Action</th>
            </tr>
          </thead>
          <tbody>
            {assets.map((asset) => {
              const colors = BRAND_COLORS[asset.brand];
              return (
                <tr key={asset.id} className="border-b hover:bg-slate-50">
                  <td className="p-4">
                    {asset.type === 'file' ? asset.fileName : 
                     asset.type === 'link' ? 'Link' : 
                     asset.type === 'text' ? 'Text' : 'Email'}
                  </td>
                  <td className="p-4">
                    <Badge className={`${colors.badge} text-white text-xs`}>
                      {BRAND_LABELS[asset.brand]}
                    </Badge>
                  </td>
                  <td className="p-4 capitalize">{asset.type}</td>
                  <td className="p-4">{asset.submittedBy?.name}</td>
                  <td className="p-4">{new Date(asset.submittedAt).toLocaleDateString()}</td>
                  <td className="p-4">{asset.itemTitle}</td>
                  <td className="p-4">
                    {asset.type === 'file' && asset.fileUrl && (
                      <a
                        href={`${BACKEND_URL}${asset.fileUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline"
                      >
                        Download
                      </a>
                    )}
                    {asset.type === 'link' && asset.linkUrl && (
                      <a
                        href={asset.linkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline"
                      >
                        Open
                      </a>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
